module.exports = __webpack_public_path__ + "static/media/logo-white.7d6ec42c.png";